import { GroupedTable } from '../models/grouped-table';
import { PrimeColumn } from '../models/prime-column';

export type PrimeColumnProvider = (label: string, xAxisLabels: string[]) => PrimeColumn;

export function primeColumnFromLabel(label: string, xAxisLabels: string[]): PrimeColumn {
  const column: PrimeColumn = {
    field: label,
    width: 150,
    isSystemColumn: false,
    header: label,
    type: 0,
    isFrozen: xAxisLabels.indexOf(label) === 0
  };
  return column;
}

export function columnsFromXAxisLabels(table: GroupedTable, columnProvider: PrimeColumnProvider): PrimeColumn[] {
  const cols = (table && table.xAxisLabels) || [];
  return cols.map(label => {
    return columnProvider(label, table.xAxisLabels);
  });
}

export function getFrozenColumns(table: GroupedTable, columnProvider: PrimeColumnProvider): PrimeColumn[] {
  return columnsFromXAxisLabels(table, columnProvider).filter(column => column.isFrozen);
}

export function getStandardColumns(table: GroupedTable, columnProvider: PrimeColumnProvider): PrimeColumn[] {
  return columnsFromXAxisLabels(table, columnProvider).filter(column => !column.isFrozen);
}
